import React from 'react';

import { Quantity } from 'src/components/atoms/Quantity/Quantity';
import type { PriceBreakdownStateProps } from 'src/components/molecules/PriceBreakdown/PriceBreakdown';
import { PriceBreakdown } from 'src/components/molecules/PriceBreakdown/PriceBreakdown';

export interface ProductOptionsDispatchProps {
  onChangeQuantity: (payload: { quantity: number; valid: boolean }) => void;
}

export interface ProductOptionsStateProps {
  inStock: boolean;
  /** Null when the product has no options, so there is no breakdown to show. */
  priceBreakdown: PriceBreakdownStateProps | null;
  quantity: number;
}

type ProductOptionsProps = ProductOptionsDispatchProps & ProductOptionsStateProps;

export const ProductOptions = ({
  inStock,
  onChangeQuantity,
  priceBreakdown,
  quantity,
}: ProductOptionsProps) => {
  if (!inStock) {
    return null;
  }

  return (
    <>
      {priceBreakdown && <PriceBreakdown {...priceBreakdown} />}
      <Quantity
        defaultValue={quantity}
        onChange={(quantity, valid) => {
          onChangeQuantity({ quantity, valid });
        }}
      />
    </>
  );
};
